import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '#api/axios';

type EnrollSurveyArgs = {
  survey: number;
  responses: number[];
};

export default function useEnrollSurveyMutation() {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ survey, responses }: EnrollSurveyArgs) => {
      await request({
        method: 'post',
        url: `/accounts/survey`,
        data: {
          survey,
          responses
        }
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['onboard', 'survey']
        });
      }
    }
  );
}
